/**
 * Loosely validate a URL `string`.
 * Used to e.g. decide whether a user input is meant to be an url in text editors.
 * Copied from https://github.com/segmentio/is-url/blob/master/index.js
 */
export const isUrl = (string: string): boolean => {
  const protocolAndDomainRegex = /^(?:\w+:)?\/\/(\S+)$/;
  const domainRegex = /^[^\s\.]+\.\S{2,}$/;

  const match = string.match(protocolAndDomainRegex);

  if (!match) {
    return false;
  }

  const [, everythingAfterProtocol] = match;

  if (!everythingAfterProtocol) {
    return false;
  }

  if (domainRegex.test(everythingAfterProtocol)) {
    return true;
  }

  return false;
};

export const relativeUrl = (): string =>
  `${window.location.pathname}${window.location.search}${window.location.hash}`;

export const repairUrlProtocol = (url: string, defaultProtocol: string = 'http'): string => {
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }

  return `${defaultProtocol}://${url}`;
};
